import clsx from 'clsx';
import React, { useState } from 'react';
import SchemaBuilder, { SchemaBuilderProps } from './SchemaBuilder';
import { SchemaBuilderControllerProps } from '../interfaces/SchemaBuilderController';

export interface SchemaBuilderContainerProps {
  className?: string;
  children: (props: SchemaBuilderControllerProps) => React.ReactNode;
}

export function SchemaBuilderContainer({
  className = '',
  children,
}: SchemaBuilderContainerProps) {
  const [ config, setConfig ] = useState<{ visible: boolean, builderProps?: SchemaBuilderProps }>({
    visible: false
  });

  const show = (builderProps: SchemaBuilderProps) => {
    setConfig({ visible: true, builderProps });
  };

  const close = (data: any) => {
    config.builderProps.close(data);

    setConfig({
      visible: false
    });
  };

  return (<>
    <div className={clsx(className, config.visible ? 'd-none' : '')}>
      {children({ show })}
    </div>

    {config.visible ? (
      <SchemaBuilder {...config.builderProps} close={close} />
    ) : null}
  </>);
}
